import React from 'react';
import UtilityService from '../../../services/UtilityService';
import { ShippingMethodContract } from '../../../types/ShippingMethods';
import LabeledRadioButton from '../LabeledRadioButton';

export type ShippingMethodItemProps = {
  shippingMethod: ShippingMethodContract;
  selectedShippingMethod?: ShippingMethodContract | null;
  name: string;
  formattedCurrencySymbol: string;
  onShippingMethodChanged: (selectedShippingMethodId: string) => void;
};

const ShippingMethodItem: React.FC<ShippingMethodItemProps> = ({
  shippingMethod,
  name,
  formattedCurrencySymbol,
  onShippingMethodChanged,
  selectedShippingMethod,
}: ShippingMethodItemProps) => {
  const handleShippingMethodChanged = (
    event: React.ChangeEvent<HTMLInputElement>
  ): void => {
    onShippingMethodChanged(event.target.value);
  };

  const isDefaultChecked = shippingMethod.id === selectedShippingMethod?.id;

  return (
    <label htmlFor={`${name}-${shippingMethod.id}`}>
      <li className="flex flex-row py-2 pr-2">
        <div className="select-none flex flex-1 justify-between justify-items-stretch">
          <div>
            <LabeledRadioButton
              label={UtilityService.html5Decode(shippingMethod.name)}
              value={shippingMethod.id.toString()}
              name={name}
              checked={isDefaultChecked}
              onChange={handleShippingMethodChanged}
            />
          </div>
          <div className="pt-2 text-md text-right pr-2">
            {formattedCurrencySymbol}
            {shippingMethod.price.toFixed(2)}
          </div>
        </div>
      </li>
    </label>
  );
};

export default ShippingMethodItem;
